import {
  createCheckouSessionUrl,
  createConektaCreditsEndpoint, deleteGroupsUsers,
  getAllMyPermissions, getGroupsUsers,
  getMyCredits,
  getMyHistoryCredits,
  getMyPostalCodeUrl, getUserIsAdmin,
  saveCreditsOrder, saveGroupsUsers, sendEmailCard,
  validateCurrentPasswordEndpoint,
  changePasswordEndpoint,
} from './endpoints'
import request from '@/utils/request'
import { validateFIELExist } from '../auth/endpoints'

export function getCheckoutSession() {
  return request(createCheckouSessionUrl, { method: 'POST' })
}


export const checkFIELExistUser = (rfc) => {
  return request(validateFIELExist, {
    method:'POST',
    body:{
      "rfc": rfc
    }
  })
}


// Credits Methods API

export const createConektaOrderCredits = (packageName,creditType,email) => {
  return request(createConektaCreditsEndpoint, {
    method:'POST',
    body:{
      "packageName":packageName,
      "creditType":creditType,
      "email":email
    }
  });
}

export const saveCreditsAndOrder = (id, email, packageName, creditType) => {
  return request(saveCreditsOrder, {
    method:'POST',
    body:{
      "id":id,
      "email":email,
      "packageName":packageName,
      "creditType":creditType
    }
  });
}


export const getAllMyCredits = (email) => {
  return request(getMyCredits, {
    method:'POST',
    body:{
      "email":email
    }
  });
}


export const getHistoryCredits = (email) => {
  return request(getMyHistoryCredits, {
    method:'POST',
    body:{
      "email":email
    }
  })
}


export const getMyPostalCode = (email) => {
  return request(getMyPostalCodeUrl, {
    method:'POST',
    body:{
      "email":email
    }
  })
}

// Permissions API methods

export const getMyPermissions = (email) => {
  return request(getAllMyPermissions, {
    method:'POST',
    body:{
      "email":email
    }
  })
}

export const userIsAdmin = (emailUsr) => {
  return request(getUserIsAdmin, {
    method: 'POST',
    body:{
      "emailUser":emailUsr
    }
  })
}

export const getAllGroupsAndUserByAccountName = (name) => {
  return request(getGroupsUsers, {
    method: 'POST',
    body:{
      "name":name
    }
  })
}

export const saveSelectedUsersInGroups = (accountName, codeGroup, emails) => {
  return request(saveGroupsUsers, {
    method: 'POST',
    body:{
      "groupCode":codeGroup,
      "accountName":accountName,
      "emails":emails,
    }
  })
}

export const deteleUserFromGroup = (accountName, email) => {
  return request(deleteGroupsUsers,{
    method: 'POST',
    body:{
      "accountName":accountName,
      "email":email,
    }
  })
}

// Conekta Emils Card Method

export const sendEmailToUserCard = (accountName) => {
  return request(sendEmailCard, {
    method: 'POST',
    body:{
      "accountName":accountName,
    }
  })
}
export const validateCurrentPassword = (email, username, id, password) => {
  return request(validateCurrentPasswordEndpoint, {
    method: 'POST',
    body: {
      email,
      username,
      id,
      password,
    }
  })
}

export const changePassword = (email, username, id, password) => {
  return request(changePasswordEndpoint, {
    method: 'POST',
    body: {
      email,
      username,
      id,
      password,
    }
  })
}
